import type { JSX } from "react";

import { cn } from "../lib/utils.js";

/** Thin progress bar. `value` is a 0..1 fraction (clamped). Tone picks the
 *  fill color from the status palette. Replaces the old `.gauge` / `.fill`. */
export function Gauge({
  value,
  tone = "brand",
  className,
}: {
  value: number;
  tone?: "brand" | "good" | "warn";
  className?: string;
}): JSX.Element {
  const fill = tone === "good" ? "bg-good" : tone === "warn" ? "bg-warn" : "bg-brand";
  const pct = Math.min(100, Math.max(0, value * 100));
  return (
    <div className={cn("bg-muted h-2 overflow-hidden rounded-full", className)}>
      <div className={cn("h-full rounded-full", fill)} style={{ width: `${String(pct)}%` }} />
    </div>
  );
}
